<template>
                <div v-if="currentView === 'mail_queue'">
                    <div class="page-header"><div><div class="page-title">郵件佇列管理</div><div class="page-subtitle">查看與管理待投遞的郵件佇列</div></div></div>
                    <div class="card p-6 mb-6">
                        <div class="flex justify-between items-center mb-4">
                            <div class="flex gap-4">
                                <button @click="fetchMailQueue"
                                    class="btn btn-primary">重新整理</button>
                                <button @click="flushQueue"
                                    class="btn btn-primary">嘗試投遞
                                    (Flush)</button>
                            </div>
                            <button @click="deleteAllQueue"
                                class="btn btn-danger">清空所有佇列</button>
                        </div>

                        <table class="data-table">
                            <thead>
                                <tr class="border-b" style="background:var(--gray-100);">
                                    <th class="p-2">ID</th>
                                    <th class="p-2">時間</th>
                                    <th class="p-2">寄件者</th>
                                    <th class="p-2">收件者</th>
                                    <th class="p-2">大小</th>
                                    <th class="p-2">狀態</th>
                                    <th class="p-2">操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="mailQueue.length === 0">
                                    <td colspan="7" class="p-8 text-center" style="color:var(--gray-500);">
                                        目前佇列中沒有信件
                                    </td>
                                </tr>
                                <tr v-for="item in mailQueue" :key="item.queue_id" class="border-b">
                                    <td class="p-2 font-bold" style="color:var(--primary);">{{ item.queue_id }}</td>
                                    <td class="p-2">{{ item.arrival_time }}</td>
                                    <td class="p-2">{{ item.sender }}</td>
                                    <td class="p-2">
                                        <div v-for="rcpt in item.recipients" :key="rcpt">{{ rcpt }}</div>
                                    </td>
                                    <td class="p-2">{{ item.size }}</td>
                                    <td class="p-2 text-xs">
                                        <span v-if="item.status === 'Active'"
                                            class="px-2 py-1 rounded" style="background:var(--success-light,#dcfce7);color:var(--success-dark,#166534);">Active</span>
                                        <span v-else class="px-2 py-1 rounded" style="background:var(--warning-light,#fef9c3);color:var(--warning-dark,#854d0e);">{{
                                            item.status }}</span>
                                    </td>
                                    <td class="p-2">
                                        <button @click="deleteQueueItem(item.queue_id)"
                                            style="color:var(--danger);">刪除</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Log Analysis View -->

</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useAppStore } from '../store/app.js'

const store = useAppStore()

// Spread all store state as reactive refs accessible in template
const stateRefs = storeToRefs(store)
// Destructure - Vue compiler exposes all variables declared in <script setup> to template
const {
  // Core state
  token, currentView, currentUser, loginForm, loginError,
  branding, notifications, showNotifPanel,
  // Command palette
  showCmdPalette, cmdQuery, cmdResults, cmdGrouped, cmdDefaults, cmdSelIdx,
  // Domain / Users / Departments
  domains, domainForm, showDomainForm, domainLoading,
  users, userForm, showUserForm, userLoading, userError,
  departments, deptForm, showDeptForm, deptLoading,
  // Contacts / Groups
  contacts, contactForm, showContactForm, contactLoading,
  groups, groupForm, showGroupForm, groupLoading,
  // Mail
  mailQueues, mailQueueLoading, mailQueueFilter,
  serviceStatus, serviceLoading,
  // Invoice Drive
  invoiceDriveState,
  // Quotes / Products
  quotes, quoteForm, showQuoteForm, quoteLoading,
  products, productForm, showProductForm, productLoading,
  priceBooks, priceBookForm, showPriceBookForm,
  // SSL
  sslCerts, sslLoading, sslDomain,
  // Security
  securityWizardStep, spamStats,
  securityFilterState,
  // Server settings
  serverMailSettings, serverDnsSettings, serverDbSettings, serverAiSettings,
  backupSettings,
  // Logs / Audit
  logs, logFilter, logLoading,
  mailAuditRecords, auditFilter, auditLoading,
  securityAuditLogs, securityAuditFilter,
  logAnalysisResult, logAnalysisLoading,
  // AI / RAG / Sales
  ragState, aiSalesState, aiMarketingState,
  // LINE
  lineSupportState,
  // Webmail
  webmailState, webmailAutoScanInvoices, webmailAutoScanMarkRead,
  // Unreplied
  unrepliedEmails, unrepliedLoading,
  // CBI
  cbiInsights, cbiLoading,
  // Misc
  sidebarCollapsed, sidebarMobile,
  journeyEnrollments, journeyEnrollmentsLoading,
  journeyFunnel, journeyFunnelLoading, journeyFunnelFilters,
  showJourneyEditorModal, showJourneyFunnelModal, showJourneyEnrollmentsModal,
  selectedJourneyForEnrollments, selectedJourneyForFunnel,
  journeyEditorForm,
  mailQueue,
} = stateRefs

// Methods are accessed directly from store (not reactive, no storeToRefs needed)
const {
  login, logout, switchSidebarView, canAccess,
  openCommandPalette, closeCmdPalette, updateCmdResults, execCmdItemById,
  moveCmdSel, toggleNotifPanel, markNotifRead, clearNotifs,
  fetchDomains, saveDomain, deleteDomain,
  fetchUsers, saveUser, deleteUser, resetUserPassword,
  fetchDepartments, saveDepartment, deleteDepartment,
  fetchContacts, saveContact, deleteContact, importContacts,
  fetchGroups, saveGroup, deleteGroup,
  fetchMailQueue, releaseMailQueueItem, deleteMailQueueItem, flushMailQueue,
  fetchServiceStatus, fetchSpamStats,
  fetchSslCerts, issueSslCert, deleteSslCert,
  fetchProducts, saveProduct, deleteProduct,
  fetchPriceBooks, savePriceBook, deletePriceBook,
  fetchQuotes, saveQuote, deleteQuote, sendQuote,
  fetchLogs, fetchLogAnalysis,
  fetchMailAuditRecords, fetchSecurityAuditLogs,
  fetchServerMailSettings, saveServerMailSettings,
  fetchServerDnsSettings, saveServerDnsSettings,
  fetchServerDbSettings, saveServerDbSettings,
  fetchServerAiSettings, saveServerAiSettings,
  fetchBackupSettings, saveBackupSettings, triggerBackup,
  fetchSecurityFilter, saveSecurityFilter,
  fetchRagDocuments, uploadRagDocument, deleteRagDocument, queryRag,
  fetchUnreplied,
  fetchCbiInsights,
  loadBrandingFromLocal, saveBranding,
  safeArr, keyById,
  invoiceDriveCanGotoAdjacent, invoiceDriveGotoAdjacent,
  openInvoiceDetail, closeInvoiceDetail,
  flushQueue, deleteAllQueue, deleteQueueItem,
} = store
</script>

